import { Form, Input } from 'antd';

interface AccountSettingFormProps {
	initialValues: {
		business_name: string;
	};
}

const AccountSettingForm: React.FC<AccountSettingFormProps> = ({ initialValues }) => {
	return (
		<Form.Item name="business_name" noStyle>
			<Input
				placeholder="Please enter your business name"
				defaultValue={initialValues.business_name}
				className="w-full"
			/>
		</Form.Item>
	);
};

export default AccountSettingForm;
